import React from 'react';
import { Wrapper } from '../../components_desktop/css_global/utils.css';

const ReviewsInvitation = () => (
  <Wrapper font={'"Avenir", "Arial", sans-serif'} fontWeight="300" lineHeight="18px">
    Curious about shopping with italist? Check out what real customers are saying below! Feedback comes from a
    post-purchase survey and reviews are shown in real time.
  </Wrapper>
);

export default ReviewsInvitation;
